import i18n from "lib/i18n"
import React, { useEffect, useRef, useState } from "react"
import PropTypes from "prop-types"
import AmountButton from "components/AmountButton"
import TextField from "components/common/TextField"

const CustomAmountButton = ({
  active = true,
  amount = "100",
  error = false,
  label = "",
  secondaryLabel = "",
  onClick = () => {},
  onInput = () => {},
  selected = false,
}) => {
  const [loaded, setLoaded] = useState(false)
  const amountInput = useRef(null)

  useEffect(() => {
    if (!loaded) {
      setLoaded(true)
    }
  }, [loaded])

  const handleClick = () => {
    amountInput.current.focus()
    onClick(amountInput.current.value)
  }

  const handleChange = (event) => {
    onInput(event.target.value)
  }

  return (
    <AmountButton
      active={active}
      className="mt-1 rounded-xs border border-gray-300 shadow-none"
      label={label}
      secondaryLabel={secondaryLabel}
      margin="0"
      onClick={handleClick}
      selected={selected}
    >
      <TextField
        autoComplete={false}
        classes="max-w-[236px] mr-2"
        disabled={!active}
        error={error}
        id="customAmount"
        inputRef={amountInput}
        onChange={handleChange}
        pattern="[0-9]*"
        placeholder={i18n.t("donation.placeholder.custom_amount")}
        type="number"
        value={amount}
      />
    </AmountButton>
  )
}

CustomAmountButton.propTypes = {
  active: PropTypes.bool,
  amount: PropTypes.string,
  error: PropTypes.bool,
  label: PropTypes.string,
  secondaryLabel: PropTypes.string,
  onClick: PropTypes.func,
  onInput: PropTypes.func,
  selected: PropTypes.bool,
}

export default CustomAmountButton
